import { createIcon } from '../createIcon';

export const ApplicationsIconConfig = {
  name: 'ApplicationsIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M951.9,320 L832,320 L832,135 C832,94.9 800.7,64 760.5,64 L71.1,64 C30.9,64.1 0,94.9 0,135 L0,696.9 C0,737.1 30.9,768 71.1,768 L192,768 L192,952.2 C192,992.5 223.4,1024 263.7,1024 L952,1024 C992.3,1024 1024,992.5 1024,952.2 L1024,391 C1023.9,350.9 992.1,320 951.9,320 Z M832,384 L896,384 L896,448 L832,448 L832,384 Z M640,128 L704,128 L704,192 L640,192 L640,128 Z M64,704 L64,256 L768,256 L768,704 L64,704 Z M960,960 L256,960 L256,768 L760.5,768 C800.8,768 832,736.5 832,696.3 L832,576 L960,576 L960,960 Z',
  yOffset: 0,
  xOffset: 0,
};

export const ApplicationsIcon = createIcon(ApplicationsIconConfig);

export default ApplicationsIcon;